import type { FC, ReactNode } from 'react';
import { Titled } from 'react-titled';
import { Box, Typography } from '@mui/material';

interface StickyLayoutProps {
  children: ReactNode;
  pageTitle: string;
  id: string;
  titleAdornment?: ReactNode;
}
const StickyLayout: FC<StickyLayoutProps> = ({ children, pageTitle, id, titleAdornment }: StickyLayoutProps) => {
  return (
    <>
      <Titled title={(title) => `${pageTitle} | ${title}`} />
      <Box sx={{ display: 'flex', flexGrow: 1, position: 'relative' }}>
        <Box id={id} sx={{ position: 'absolute', height: '100%', left: 0, top: 0, right: 0, overflow: 'scroll' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              mt: 3,
              ml: 3,
              mr: 3,
              mb: 2,
            }}
          >
            <Typography variant="h5">{pageTitle}</Typography>
            {titleAdornment ? (
              <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, justifyContent: 'flex-end', minWidth: 0 }}>
                {titleAdornment}
              </Box>
            ) : null}
          </Box>
          {children}
        </Box>
      </Box>
    </>
  );
};

export default StickyLayout;
